import "./InbetweenConcept.css";

function InbetweenConcept() {
  return (
    <section className="book-idea-wrapper">
      <div className="book-idea-card">

        {/* LEFT SIDE */}
        <div className="idea-left">
          <p className="idea-eyebrow">Core Concept</p>
          <h2 className="idea-title">
            The secret to{" "}
            <span className="underline-word">Growth</span>{" "}
            isn't Intensity.
            <br />
            It's <span className="highlight-word">Balance.</span>
          </h2>
          <p className="idea-sub">
            You won't just improve — you'll evolve without burning out.
          </p>
          <p className="idea-text">
            Life isn't meant to be maximized or minimized.
            It's meant to be calibrated.
            And the optimal point exists somewhere in{" "}
            <strong>The In-Between.</strong>
          </p>
        </div>

        {/* RIGHT SIDE — SVG Diagram */}
        <div className="idea-right">
          <svg
            className="zone-svg"
            viewBox="0 0 560 480"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <marker id="arrowhead" markerWidth="9" markerHeight="9" refX="4.5" refY="4.5" orient="auto">
                <path d="M0,0 L9,4.5 L0,9 Z" fill="#2c1f14" />
              </marker>
              <pattern id="gridpat" width="22" height="22" patternUnits="userSpaceOnUse">
                <path d="M 22 0 L 0 0 0 22" fill="none" stroke="#c9b9a8" strokeWidth="0.6" />
              </pattern>
              <radialGradient id="glowFill" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#b8956a" stopOpacity="0.28" />
                <stop offset="100%" stopColor="#b8956a" stopOpacity="0" />
              </radialGradient>
            </defs>

            {/* Grid BG */}
            <rect width="560" height="480" fill="#faf5ee" />
            <rect width="560" height="480" fill="url(#gridpat)" />

            {/* Glow blob between curves */}
            <ellipse cx="300" cy="240" rx="175" ry="90" fill="url(#glowFill)" />

            {/* Y Axis */}
            <line x1="72" y1="440" x2="72" y2="30"
              stroke="#2c1f14" strokeWidth="2.5" markerEnd="url(#arrowhead)" />

            {/* X Axis */}
            <line x1="72" y1="440" x2="530" y2="440"
              stroke="#2c1f14" strokeWidth="2.5" markerEnd="url(#arrowhead)" />

            {/* TOP CURVE */}
            <path
              d="M 100 240 C 170 240, 220 115, 300 115 C 380 115, 430 240, 500 240"
              fill="none" stroke="#2c1f14" strokeWidth="4.5" strokeLinecap="round"
            />

            {/* BOTTOM CURVE */}
            <path
              d="M 100 240 C 170 240, 220 365, 300 365 C 380 365, 430 240, 500 240"
              fill="none" stroke="#2c1f14" strokeWidth="4.5" strokeLinecap="round"
            />

            {/* Too Much label */}
            <text x="365" y="108"
              fontFamily="'Newsreader', Georgia, serif"
              fontSize="20" fontWeight="700" fill="#2c1f14">Too Much</text>

            {/* Too Little label */}
            <text x="355" y="398"
              fontFamily="'Newsreader', Georgia, serif"
              fontSize="20" fontWeight="700" fill="#2c1f14">Too Little</text>

            {/* Center labels */}
            <text x="300" y="226" textAnchor="middle"
              fontFamily="'Newsreader', Georgia, serif"
              fontSize="20" fontWeight="700" fill="#2c1f14">The In-Between</text>

            <text x="300" y="254" textAnchor="middle"
              fontFamily="'Poppins', sans-serif"
              fontSize="13" fill="#8c6248" letterSpacing="1.5"
              fontWeight="500">OPTIMAL ZONE</text>

          </svg>
        </div>

      </div>
    </section>
  );
}

export default InbetweenConcept;